export interface WrapInputModel<T> {
  data: T;
}

export interface WrapOutputModel<T> {
  action: T;
  data?: any;
}
